export default __webpack_public_path__ + "static/char-s-58-zh-Hans-fc47b6c9afca63adaffa4665e051c114.png";